/**
 * Test IDs for QA automation.
 */
export const testIds = {
  invoiceDetailsChargeTable: (chargeType: string) =>
    `invoice-details-charge-table-${chargeType.toLowerCase()}`,
  invoiceDetailsChargeTableAddCharge: "invoice-details-charge-table-add-charge",
} as const;
